import { LoaderFunction } from 'react-router-dom';
import { client } from '~/api/client';
import { queryData } from '~/api/data/request';
import { loadQuery } from '~/api/data/responses';
import {
  AgencyUsageFieldsFragment,
  GetAgencyUsageDocument,
  GetAgencyUsageQuery,
  GetAgencyUsageQueryVariables
} from '~/api/graphql';

export const getAgencyUsage = async (timezone?: string) => {
  return queryData<GetAgencyUsageQuery, GetAgencyUsageQueryVariables, AgencyUsageFieldsFragment>(
    client,
    { query: GetAgencyUsageDocument, variables: { timezone: timezone } },
    (data) => data?.agencyUser?.agency
  );
};

export const loadAgencyUsage: LoaderFunction = ({ request }) =>
  loadQuery(getAgencyUsage(new URL(request.url).searchParams.get('timezone') || undefined));
